// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1viIt","title":"ClientReferral_title__3G3Do","itemText":"ClientReferral_itemText__2zAfc"};